import {remove} from 'lodash';
import {EditableBoundary, PModuleMeasurement, PModuleWithMeasurements} from '../interfaces';
import {findIndex} from 'lodash';
import measurementsStoreModule from '@/store/modules/entities/measurementsModule';

/*
  Хранилище для измерений ПМ Датчик Температуры
*/

export class PModuleMeasurementStore {
  private parent: PModuleWithMeasurements;
  private editableBoundaries: EditableBoundary;

  constructor(
    parent: PModuleWithMeasurements,
    editableBoundaries: EditableBoundary = {
      topWarningBoundary: true,
      topDangerBoundary: true,
      topErrorBoundary: true,
    },
  ) {
    this.parent = parent;
    this.editableBoundaries = editableBoundaries;
    if (!this.parent.measurements) this.parent.measurements = [];
  }

  async fetchAll() {
    if (this.parent.measurements) {
      this.parent.measurements = [...this.parent.measurements];
    }
  }

  get all() {
    return [...(this.parent.measurements as PModuleMeasurement[])];
  }

  //получение create модели
  async create(): Promise<{data: PModuleMeasurement}> {
    return {data: {measurementId: undefined, parent: this.parent}};
  }

  //получение edit модели
  async edit(measurementId: any): Promise<{data: PModuleMeasurement | null}> {
    const filteredModels = this.parent.measurements?.filter(x => x.measurementId === measurementId);

    let model: PModuleMeasurement | null = null;
    if (filteredModels?.length)
      model = {
        ...filteredModels[0],
        parent: this.parent,
        editableBoundaries: this.editableBoundaries,
      };
    return {data: model};
  }

  //сохранение
  async save(model: PModuleMeasurement) {
    if (this.parent.measurements) {
      const measurement = await measurementsStoreModule.edit(model.measurementId);
      model.measurementDescription = measurement.data?.name;
      const index = findIndex(this.parent.measurements, {measurementId: model.measurementId});
      if (index < 0) this.parent.measurements?.push(model);
      else this.parent.measurements?.splice(index, 1, model);
    }
    return {data: {success: true}};
  }

  //удаление
  async delete(measurementId: any) {
    remove(
      this.parent.measurements as PModuleMeasurement[],
      (p: any) => p.measurementId === measurementId,
    );
    return {data: {success: true}};
  }
}
